// jsonGetRoute — wraps a Rill GET action handler that proxies a single
// api(...) call and responds with JSON. Handles the Content-Type header,
// passes a non-ok response's status/body through verbatim, and catches
// thrown errors into a { error } 500 — the shape shared by every read-only
// proxy route added for useExtendedHistoryData (exercise.js's
// "/exercise/active-range", personal-records.js, habit-logs.js): each only
// differs in what api() call it makes and how (if at all) it reshapes the
// successful response body.
//
// buildRequest(ctx) => [apiPath, apiOptions] — the api(...) call to make.
// Return a falsy value instead to skip the api() call entirely (e.g.
// personal-records.js's isAfterToday(end) bail) — the route responds
// immediately with transform(null).
// transform(data) => body — optional, reshapes the parsed JSON before it's
// stringified (e.g. habit-logs.js unwraps { habitLogs } to a bare array).
// Defaults to passing the parsed data through unchanged.
export const jsonGetRoute = (buildRequest, transform = (data) => data) => async (ctx) => {
  const { res, api } = ctx;
  res.headers = res.headers || {};
  res.headers["Content-Type"] = "application/json; charset=utf-8";
  try {
    const request = buildRequest(ctx);
    if (!request) {
      res.status = 200;
      res.body = JSON.stringify(transform(null));
      return;
    }

    const [path, options] = request;
    const response = await api(path, options);
    if (!response.ok) {
      res.status = response.status;
      res.body = await response.text();
      return;
    }
    const data = await response.json().catch(() => null);
    res.status = 200;
    res.body = JSON.stringify(transform(data));
  } catch (e) {
    res.status = 500;
    res.body = JSON.stringify({ error: e.message || "Request failed" });
  }
};
